export const pianoErrorCodes = {
  passwordLessLoginError: 1434,
  userExistsError: 1213,
};
